import index from '@/pages/Blog/Index.vue'
import frettir from '@/pages/Blog/Frettir.vue'
import vidburdir from '@/pages/Blog/Vidburdir.vue'
import reynsluakstur from '@/pages/Blog/Reynsluakstur.vue'
import post from '@/pages/Blog/SimplePost.vue'

// Routes Names
import {blog, news, events, testdrive} from '@/staticData/routesName/blog'
const id = '/:id'

export default [
    {
        path: blog,
        name: 'Blog',
        component: index
    },
    {
        path: blog + news,
        name: 'Fréttir',
        component: frettir
    },
    {
        path: blog + news + id,
        name: 'FréttirSimplePost',
        component: post
    },
    {
        path: blog + events,
        name: 'Viðburðir',
        component: vidburdir
    },
    {
        path: blog + events + id,
        name: 'ViðburðirSimplePost',
        component: post
    },
    {
        path: blog + testdrive,
        name: 'Reynsluakstur',
        component: reynsluakstur
    },
    {
        path: blog + testdrive + id,
        name: 'ReynsluaksturSimplePost',
        component: post
    }
]
